import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { PickerItem } from "@my-dld/components/Picker";
import { EIDLogin, EIDModal } from "./EID";
import { Entities, IdentityApi, IdentityEntity } from "@10x/dubai-rest-api";
import VerifyPopup from "@my-dld/components/VerifyPopup";
import { MobileLogin } from "./Mobile";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { TitleDeedLogin } from "./TitleDeed";
import { IAppLoginState, ILoader } from "../index";
import { I8N, ServerDate, StringUtil } from "@eres/core";
import { setTabuUser, setToken } from "@my-dld/utils/User";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { AuthResponse, AuthResult, Profile } from "@10x/dubai-rest-api/dist/identity/entity";
import { VIPOwnerAPI } from "@eres/vipownerapi";
import EidaUpdate from "./EIDAUpdate";
import { RegistrationApi, TabuUtils } from "@10x/tabu-mobile-api";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { dispatch, navigate, navigateWithInParent } from "@my-dld/utils/StoreUtils";
import Action from "@my-dld/actions";
import Actions from "@my-dld/actions";
import { ITabuProfile } from "@10x/tabu-mobile-api/dist/registartion/entities";
import { EmailLogin } from "./Email";
import { BaseLoginScreen, LoginOptions } from "../BaseLoginScreen";
import { AppConstants } from "../../../configApp";
import * as base64 from "js-base64";
import { getUaePassUrl } from "@eres/ssoapi/api";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import urlParser from "urijs";
import { featureGateCheck } from "@my-dld/utils/Utils";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";

export type LoginType = "EmiratesId" | "Mobile" | "TitleDeed" | "Email";

export interface ILoginComponent<P, S> extends Component<P, S> {
	doLogin: ( loader: ILoader ) => Promise<{ method: LoginType, id: string, result: IdentityEntity.AuthResult }>;
}

export interface ILoginComponentClass<P, S> {
	new( props: P, context?: any ): ILoginComponent<P, S>;
}

type LoginComponent<P, S> = React.ComponentClass<P, S> & ILoginComponentClass<P, S>;

export interface ILoginTrack extends PickerItem {
	screen: LoginComponent<any, any>;
	iconClass?: string;
	modal?: any;
}

interface Prop extends RoutedViewProps {

}


interface State {
	current: ILoginTrack;
	step: "form" | "verify" | "eida" | "eidarecover";
	authResult?: IdentityEntity.AuthResult;
	method?: LoginType;
	id?: string;
	isPassCode?: boolean;
	mobile?: string;
	email?: string;
	maskedNumber?: string;
	dob?: ServerDate;
	showMobileOTP: boolean;
	loginTrack: ILoginTrack[];
	isKycRequired?: boolean;
}

class Login extends Component<Prop, State> {
	form = React.createRef<ILoginComponent<any, any>>();
	vp = React.createRef<VerifyPopup>();
	eidaVp = React.createRef<VerifyPopup>();
	eidaUpdate = React.createRef<EidaUpdate>();

	constructor( props: Prop ) {
		super( props );
		const show = featureGateCheck( "showMobileOTP" );
		this.state = {
			current: LoginTracks[ 0 ],
			step: "form",
			showMobileOTP: show,
			loginTrack: show ? LoginTracks : LoginTracks.filter( x => x.id !== "Mobile" ),
		};
	}

	onSwitchToOther = () => {
		navigateWithInParent( "login", "sso" );
	};
	onTypeChange = ( id: string ) => {
		this.setState( { current: this.state.loginTrack.find( x => x.id === id )! } );
	};
	onUaePass = () => {
		const ln = I8N.locale();
		const appState: IAppLoginState = {
			module: "uaepass",
			sso: false,
			ln: ln,
			mode: "login",
		};
		const state = base64.encode( JSON.stringify( appState ) );
		const passUrl = getUaePassUrl( ln, state );
		window.location.href = passUrl;
	};

	componentDidMount() {
		if ( this.props.location?.search ) {
			let x = urlParser( this.props.location?.search ).query( true ) as any;
			const token = x[ "rest-token" ];
			const kycRequired = x[ "kyc-required" ];
			if ( token ) {
				showLoading();
				setToken( token );
				IdentityApi.me().then( x => {
					const profile = x?.response?.profile;
					if ( profile ) {
						dispatch( Actions.SET_IS_UAE_PASS_USER, true );
						setTabuUser( profile );
						navigate( "/mydld" );
					}
					hideLoading();
				} ).catch( e => {
					showErrorMessage( e.toString() );
					hideLoading();
				} );
			}
			if ( kycRequired ) {
				this.setState( { isKycRequired: true } );
			}
		}
	}

	render() {
		const { mobile, email, isPassCode, maskedNumber, showMobileOTP, isKycRequired } = this.state;
		const { current } = this.state;

		const channelId = current?.id;
		const otps: string[] = [];
		if ( showMobileOTP && mobile ) otps.push( mobile );
		if ( email ) otps.push( email );
		const modifiedOTPMessage = showMobileOTP ?
			Strings.we_have_sent_pass_code_to_your_registered_mobile_number + ( email ? ( " / " + Strings.email ) : "" ) :
			Strings.we_have_sent_pass_code_to_your_registered_email_id;

		const UAEPassIcon = `Button_UAE_Pass_${ I8N.locale() }_Login`;
		return (
            <BaseLoginScreen>
                <div className="container mw-1100">
                <div className="row g-0" id="businessUser">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="auth-container-form card">
                                <div className="auth-title">
                                    <span>{ Strings.login_as_individual_via }</span>
                                    <button
                                        className="btn-link btn-switch-user" onClick={ this.onSwitchToOther }
                                        id="switchIndividual">{ Strings.login_as_business_user }</button>
                                </div>
                                    <LoginOptions
                                        items={ this.state.loginTrack } checkedId={ channelId ?? "" }
                                        onChange={ this.onTypeChange }/>

                                <div className="auth-container-form" id="emiratesID">
                                    { this.state.current &&
                                        <this.state.current.screen ref={ this.form }/>
                                    }
                                </div>

                                <div className="form-group mt-3">
                                    <button
                                        className="btn btn_style1 btn_1 btn-block fs-5"
                                        onClick={ this.doLogin }>{ Strings.login }</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-1 d-flex align-items-center justify-content-center">
                            <div className="or-seprator-v">{ Strings.or_caps }</div>
                        </div>
                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                            <div className="card col-uaepass">
                                <div className="auth-title">
                                    <span>Login with UAE PASS</span>
                                </div>
                                <div className="uaepass-infodiv">
                                    <img src={`${AppConstants.rootUrl}/assets/img/uae-pass.svg`} alt="UAE Pass Logo" />
                                </div>
                                <div className="text-center">
                                    UAE PASS is a single trusted<br />
                                    national digital identity for all citizens, <br />
                                    residents and visitors.
                                </div>
                                <button className="btn btn-login-uaepass" onClick={this.onUaePass}>
                                    <span className="sr-only">Login with UAE Pass</span>
                                </button>
                                <div className="uaepass-registration">
                                    <span>
                                        Don't have UAE PASS account? <a href="https://uaepass.ae/" rel="noopener noreferrer" target="_blank">Create Account</a>
                                    </span>
                                    <span>
                                        How to Register for UAE PASS? <a href="https://www.youtube.com/watch?v=M62taRz58f0" rel="noopener noreferrer" target="_blank">Watch Video</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
				{ this.state.current && this.state.current.modal &&
					<this.state.current.modal/>
				}
				{ this.state.step === "verify" &&
					<VerifyPopup
						showPasscodeAnnouncement={ window.AppInfo.showPasscodeHelpForOwner }
						ref={ this.vp }
						hideVCode={ isPassCode }
						id={ this.state.id! }
						message={ isPassCode ? Strings.please_enter_your_pass_code : ( modifiedOTPMessage + "\n" + otps.join( " / " ) ) }
						maxLength={ 7 }
						onDismiss={ this.onVerifyDismiss }
						onVerify={ this.onVerify }
						hasResend={ true }
						resend_label={ Strings.forgot_passcode }
						resend_label_link={ Strings.resend }
						onResend={ this.regenPassCode }
						loginId={ this.state.id }
					>
						{ showMobileOTP && this.state.method === "EmiratesId" && !StringUtil.isEmptyStringOrNull( this.state.id ) && <>
							<EidaUpdate
								id={ this.state.id! } ref={ this.eidaUpdate }
								onEidaStarted={ this.onEidaStarted }/>
						</> }
					</VerifyPopup>
				}
				{ this.state.step === "eida" &&
					<VerifyPopup
						noCredentialSave={ true }
						showPasscodeAnnouncement={ false }
						ref={ this.eidaVp }
						hideVCode={ isPassCode }
						id={ this.state.id! }
						message={ Strings.eida_send_otp_mobile_number.format( [ maskedNumber! ] ) }
						maxLength={ 7 }
						onDismiss={ this.onVerifyDismiss }
						onVerify={ this.onEidaVerify }
						hasResend={ false }
						resend_label={ Strings.forgot_passcode }
						resend_label_link={ Strings.resend }
						onResend={ this.regenPassCode }
						loginId={ this.state.id }
					>
					</VerifyPopup>
				}
				{ this.state.step === "eidarecover" &&
					<EidaUpdate
						onDismiss={ this.onVerifyDismiss }
						showRecoverPopup={ true }
						id={ this.state.id! } ref={ this.eidaUpdate } onEidaStarted={ this.onEidaStartedFromRecovery }
					>
					</EidaUpdate>
				}
				{ isKycRequired && <ConfirmationPopup
					primaryLabel={ Strings.update }
					secondaryLabel={ Strings.close }
					message={ Strings.kyc_update_description }
					onConfirm={ this.onUpdate }
					onCancel={ this.onClose }/> }
			</BaseLoginScreen>
		);
	}

	private onUpdate = () => {

	};

	private onClose = () => {
		this.setState( { isKycRequired: false } );
	};

	onEidaStarted = ( maskedNumber: string ) => {
		this.vp.current?.hide( () => {
			this.onEidaInit( maskedNumber );
		} );

	};
	onEidaStartedFromRecovery = ( maskedNumber: string ) => {
		JQModal( "eidarecover" ).hide( () => {
			this.onEidaInit( maskedNumber );
		} );

	};
	onEidaInit = ( maskedNumber: string ) => {
		this.setState( {
			step: "eida",
			maskedNumber: maskedNumber,
		} );
	};
	onVerifyDismiss = () => {
		this.setState( { step: "form" } );
	};
	regenPassCode = () => {
		let api: ( ( id: string, dob: ServerDate, isResend?: boolean ) => Promise<AuthResponse> ) | undefined = undefined;
		if ( this.state.method === "EmiratesId" ) {
			api = IdentityApi.loginByEID;
		} else if ( this.state.method === "Mobile" ) {
			api = IdentityApi.loginByMobile;
		} else if ( this.state.method === "TitleDeed" ) {
			api = IdentityApi.loginByCertificate;
		} else if ( this.state.method === "Email" ) {
			api = IdentityApi.loginByEmail;
		}
		if ( api != null ) {
			this.eidaUpdate.current?.onOtherTask( true );
			return api( this.state.id!, this.state.dob!, true )
			.then( Entities.validateResponse )
			.then( result => {
				this.eidaUpdate.current?.onOtherTask( false );
				this.HandleLoginResponse( {
					result: result,
					method: this.state.method!,
					id: this.state.id!,
					dob: this.state.dob,
				} );
			} )
			.catch( e => {
				this.eidaUpdate.current?.onOtherTask( false );
				return Promise.reject( e.toString() );
			} );
		} else {
			this.eidaUpdate.current?.onOtherTask( false );
			return Promise.resolve( () => {
			} );
		}
	};
	onVerify = ( otp: string ) => {
		trackEventWithData( "Login", "TryVerifyOTP", { method: this.state.method, id: this.state.id } );
		this.eidaUpdate.current?.onOtherTask( true );
		return IdentityApi.verifyOTP( this.state.method!, this.state.id!, otp!, this.state.dob! )
		.then( Entities.validateResponse )
		.then( r => {
			if ( r && r.profile && r.status !== "UnVerified" && r.profile.isVerified ) {
				trackEventWithData( "Login", "VerifyOTPSuccess", { method: this.state.method, id: this.state.id } );
				return this.loadOwnerCategory( r.profile );
			}
			trackEventWithData( "Login", "VerifyOTPFailed", { method: this.state.method, id: this.state.id } );
			this.eidaUpdate.current?.onOtherTask( false );
			throw Strings.invalid_otp;
		} ).catch( e => {
			this.eidaUpdate.current?.onOtherTask( false );
			trackEventWithData( "Login", "VerifyOTPFailed", { method: this.state.method, id: this.state.id } );
			throw e;
		} );
	};
	onEidaVerify = ( otp: string ) => {
		const id = this.state.id!;
		trackEventWithData( "Login", "TryVerifyEidaOTP", { id: id } );
		return RegistrationApi.verifyEIDAUpdate( id, otp )
		.then( x => TabuUtils.validateResponse( x, "ValidationErrors" ) )
		.then( ( r ) => {
			if ( r && r.Profile && r.Profile.isVerified ) {
				trackEventWithData( "Login", "VerifyEidaOTPSuccess", { id: id } );
				trackEventWithData( "Login", "EIDAAutoLogin", { id: id } );
				dispatch( Action.SHOW_PROFILE_UPDATED, true );
				return this.loadOwnerCategory( r.Profile );
			}
			throw Error( "VerifyOTPFailed" );
		} ).catch( e => {
			trackEventWithData( "Login", "VerifyEidaOTPError", { e: e.toString() } );
			throw e;
		} );
	};
	redirect = () => {

	};
	setLoading = ( isLoading: boolean ) => {
		if ( isLoading ) {
			showLoading();
		} else hideLoading();
	};

	doLogin = () => {
		if ( this.form.current ) {
			this.form.current.doLogin( this ).then( p => {
				this.HandleLoginResponse( p );
			} ).catch( e => {
				if ( e && e.recover && e.id ) {
					this.setState( { step: "eidarecover", id: e.id } );
				}
			} );
			return Promise.resolve( true );
		}
		return Promise.resolve( false );
	};

	private HandleLoginResponse( p: { method: LoginType; id: string; result: AuthResult, dob?: ServerDate } ) {
		let mobile: string | undefined = p.result.profile.phoneNumber;
		let email = p.result.profile.emailAddress;
		this.setState( {
			step: "verify",
			authResult: p.result,
			id: p.id,
			method: p.method,
			isPassCode: !p.result.isNewPassCode,
			mobile, email, dob: p.dob,
		} );
	}

	private loadOwnerCategory = ( profile: Profile | ITabuProfile ) => {
		trackEventWithData( "Login", "VIPCategoryTry" );
		return VIPOwnerAPI.getOwnerCategoryDetails( profile.tabuParticipantId ).then( resp => {
			trackEventWithData( "Login", "VIPCategorySuccess" );
			if ( resp ) {
				dispatch( Action.VIP_CATEGORY_CHANGED, resp );
			}
			return () => {
				setTabuUser( profile );
				this.redirect();
			};
		} ).catch( reason => {
			trackEventWithData( "Login", "VIPCategoryError", { message: reason } );
			return () => {
				dispatch( Action.VIP_CATEGORY_CHANGED, undefined );
				setTabuUser( profile );
				this.redirect();
			};
		} );
	};
}

const LoginTracks: ILoginTrack[] = [
	{
		id: "Emirates",
		value: LVStrings.emirates_id,
		screen: EIDLogin,
		modal: EIDModal,
	},
	{
		id: "Mobile",
		value: LVStrings.mobile_number,
		screen: MobileLogin
	},
	{
		id: "Email",
		value: LVStrings.email_address,
		screen: EmailLogin
    },
    {
        id: "TitleDeed",
        value: LVStrings.tittle_deed_login_label,
        screen: TitleDeedLogin
    }
];
export default Login;
